import { InputNumber } from "@/components/InputNumber";
import { datePickerStandardProps, selectStandardProps } from "@/utils/componentUtils";
import { Alert, DatePicker, Select } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { CommissionsSettingsLevelBase } from "../../../../../../commissions/level/types";
import {
  createCommissionsSettingsLevelChain,
  formatCommissionsLevelName,
} from "../../../../../../commissions/level/utils";
import { CommissionsSettingsRankBase } from "../../../../../../commissions/ranks/types";
import { createCommissionsSettingsRankChain } from "../../../../../../commissions/ranks/utils";
import {
  CommissionsSettingsLevelEnumeration,
  CommissionsSettingsRankEnumeration,
} from "../../../../../../enumerations/types";
import { DashboardGoalType } from "../../../../../enums";

type Props = {
  goalType: DashboardGoalType;
  level: { currentValue?: CommissionsSettingsLevelBase; options: CommissionsSettingsLevelEnumeration[] };
  rank: { currentValue?: CommissionsSettingsRankBase; options: CommissionsSettingsRankEnumeration[] };
  year: number;
  onChange?: VoidFunction;
  value?: any;
};

export const TargetValueFormInput = ({ goalType, level, rank, year, value, onChange }: Props) => {
  const { t } = useTranslation();

  const rankOptions = rank.currentValue
    ? createCommissionsSettingsRankChain(rank.options, rank.currentValue.id).filter(
        (option) => option.id !== rank.currentValue?.id,
      )
    : rank.options;
  const levelOptions = level.currentValue
    ? createCommissionsSettingsLevelChain(level.options, level.currentValue.id).filter(
        (option) => option.id !== level.currentValue?.id,
      )
    : level.options;

  switch (goalType) {
    case DashboardGoalType.BROKER_LEVEL:
      return levelOptions.length > 0 ? (
        <Select
          {...selectStandardProps}
          options={levelOptions.map((level) => ({ value: level.id, label: formatCommissionsLevelName(level) }))}
          value={value}
          onChange={onChange}
        />
      ) : (
        <Alert title={t("dashboard.goals.helpers.highestLevelHint")} type="info" showIcon />
      );
    case DashboardGoalType.BROKER_RANK:
      return rankOptions.length > 0 ? (
        <Select
          {...selectStandardProps}
          options={rankOptions.map((rank) => ({ value: rank.id, label: rank.name }))}
          value={value}
          onChange={onChange}
        />
      ) : (
        <Alert title={t("dashboard.goals.helpers.highestRankHint")} type="info" showIcon />
      );
    case DashboardGoalType.TIPPER_BASIC_ACADEMY:
    case DashboardGoalType.TIPPER_STATUS:
      return (
        <DatePicker
          {...datePickerStandardProps}
          minDate={dayjs(`${year}-01-01`)}
          maxDate={dayjs(`${year}-12-31`)}
          onChange={onChange}
          value={value ? dayjs(value) : undefined}
        />
      );
    default:
      return (
        <InputNumber
          addon={
            goalType === DashboardGoalType.BROKER_COMMISSIONS || goalType === DashboardGoalType.TIPPER_COMMISSIONS
              ? "euro"
              : undefined
          }
          value={value}
          onChange={onChange}
        />
      );
  }
};
